<template>
  <button
    :disabled="buttonDisabled || loading"
    :autofocus="autofocus"
    :class="classes"
    type="button"
    class="rt-button"
    @click="handleClick"
  >
    <i v-if="isLoading" class="el-icon-loading"></i>

    <span class="rt-button-content">
      <rt-icon v-if="iconName" :name="iconName" :size="iconSize" />
      <span v-if="hasdefault" class="rt-button-text"><slot></slot></span>
      <rt-icon v-if="suffixIcon" :name="suffixIcon" :size="iconSize" />
    </span>
  </button>
</template>

<script>
import RtIcon from '../icon/rtIcon';
// 定义按钮类型
const types = ['default', 'primary', 'plain'];
// 定义颜色类型
const colorTypes = ['normal', 'success', 'warning', 'info', 'sub'];
export default {
  name: 'RtButton',
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  components: {
    RtIcon
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconName: {
      type: String,
      default: ''
    },
    suffixIcon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: '16'
    },
    size: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'default'
    },
    colorType: {
      type: String,
      default: 'normal'
    },
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,
    text: Boolean,
    click: Function,
    // eslint-disable-next-line vue/require-prop-types
    tagData: {
      required: false
    }
  },
  data() {
    return {
      isDisabled: this.disabled,
      isLoading: this.loading
    };
  },
  computed: {
    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    classes() {
      let {
        type,
        buttonSize,
        colorType,
        buttonDisabled,
        loading,
        round,
        circle,
        text,
        hasdefault
      } = this;
      return [
        type ? 'rt-button--' + type : '',
        buttonSize ? 'rt-button--' + buttonSize : '',
        colorType ? 'rt-button--' + colorType : '',
        {
          'is-disabled': buttonDisabled,
          'is-loading': loading,
          'is-round': round,
          'is-circle': circle,
          'is-text': text,
          'no-text': !hasdefault
        }
      ];
    },
    hasdefault() {
      return this.$slots.default;
    }
  },
  methods: {
    async handleClick(event) {
      if (
        this.click &&
        Object.prototype.toString.call(this.click) === '[object Function]'
      ) {
        try {
          this.isDisabled = true;
          this.isLoading = true;
          await this.click();
        } catch (error) {
        } finally {
          this.isDisabled = false;
          this.isLoading = false;
        }
      } else {
        this.$emit('click', event, this.tagData);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtButton.vue?2fa350d1